export default __webpack_public_path__ + "static/media/giftBlack.fafedef7.svg";